import React from "react"

import Button from "components/Button/Button"


interface ClearFiltersButtonProps {
    onClick: () => void
}

export const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({ onClick }) => {
    return (
        <Button
            variant="text"
            onClick={onClick}
            className="text-base-primary border-none hover:bg-none text-indigo-600 text-xs"
        >
            Clear filters
        </Button>
    )
}

